export const createParentId = (parentId) => {
    return {
        parentId: parentId,
    };
};
export const createNoParentId = () => {
    return {
        parentId: null,
    };
};
export const ResourcesFolderParentId = createNoParentId();
export const createItemParentId = (parentId) => {
    // Item is in root
    if (!parentId) {
        return createNoParentId();
    }
    return createParentId(parentId);
};
export const createParentIdForResourceFolder = createNoParentId;
